import axios from "axios";
import store from "@/store";
import {AD_AZURE_LOGIN, BASIC_LOGIN, TWO_FA_LOGIN} from "@/constants/LoginTypes";

export default {
     authenticate({commit}, user) {
        return new Promise((resolve, reject) => {

            localStorage.removeItem('token');
            localStorage.removeItem('user');
            if (store.getters['app/getAppConfig']) {
                if (store.getters['app/getAppConfig'].loginType===BASIC_LOGIN) {
                    axios.post(
                        process.env.VUE_APP_BACKEND_URL + '/login',
                        user,
                        {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                        })
                        .then(resp => {
                            // TODO átmenetileg átírva a token check, hogy 2FA nélkül is be lehessen lépni
                            // if (resp.data !== "" || !resp.headers.authorization) {
                            //     throw new Error("Authentication failed");
                            // } else {
                            //     localStorage.setItem('token', resp.headers.authorization);
                            //     resolve(resp);
                            // }
                            if (!resp.data) {
                                throw new Error("Authentication failed");
                            } else {
                                localStorage.setItem('token', resp.data);
                                resolve(resp);
                            }
                        })
                        .catch(err => {
                            reject(err)
                        })
                }else if(store.getters['app/getAppConfig'].loginType===AD_AZURE_LOGIN) {
                    axios.post(
                        process.env.VUE_APP_BACKEND_URL + '/login',
                        user,
                        {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                        })
                        .then(resp => {
                            // TODO átmenetileg átírva a token check, hogy 2FA nélkül is be lehessen lépni
                            // if (resp.data !== "" || !resp.headers.authorization) {
                            //     throw new Error("Authentication failed");
                            // } else {
                            //     localStorage.setItem('token', resp.headers.authorization);
                            //     resolve(resp);
                            // }
                            if (!resp.data) {
                                throw new Error("Authentication failed");
                            } else {
                                localStorage.setItem('token', resp.data);
                                resolve(resp);
                            }
                        })
                        .catch(err => {
                            reject(err)
                        })
                }else if(store.getters['app/getAppConfig'].loginType===TWO_FA_LOGIN) {
                    axios.post(
                        process.env.VUE_APP_BACKEND_URL + '/login2FA',
                        user,
                        {
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                        })
                        .then(resp => {

                            if (resp.data !== "" || !resp.headers.authorization) {
                                throw new Error("Authentication failed");
                            } else {
                                localStorage.setItem('token', resp.headers.authorization);
                                resolve(resp);
                            }
                            if (!resp.data) {
                                throw new Error("Authentication failed");
                            } else {
                                localStorage.setItem('token', resp.data);
                                resolve(resp);
                            }
                        })
                        .catch(err => {
                            reject(err)
                        })
                }
                }
            })

        }
    }

